/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

import {Type} from '@angular/core';
import {TempUri, Uri} from './uri';

/**
 * Base class for all the models, it automatically sets getters and setters for the
 * iri and the type
 */
export abstract class Resource {
    private _iri: Uri;
    private _entityType: string;

    constructor(iri?: Uri, entityType?: string) {
        this._iri = iri || TempUri.sNewTemp(this.modelType);
        this._entityType = entityType;
        this._checkIriModel();
    }

    public static sAreTheSame(a?: Resource | null, b?: Resource | null) {
        if (a != null) {
            return a.isTheSame(b);
        } else {
            return b == null;
        }
    }

    public static sTrackByIri(index: number, resource: Resource): string {
        return resource.iri.toString();
    }

    public get isTemporalEntity(): boolean {
        return this._iri instanceof TempUri;
    }

    public get modelType(): Type<Resource> {
        return Object.getPrototypeOf(this).constructor;
    }

    public get iri(): Uri {
        return this._iri;
    }

    public set iri(value: Uri) {
        this._iri = value;
        this._checkIriModel();
    }

    public get entityType(): string {
        return this._entityType;
    }

    public set entityType(value: string) {
        this._entityType = value;
    }

    public toString(): string {
        return this.iri.toString();
    }

    /**
     * Checks whether two models are the same model in fact,
     * this is done by checking their IRIs
     * @param other
     */
    public isTheSame(other: Resource): boolean {
        if (other instanceof Resource) {
            return this.iri.isTheSame(other.iri);
        }
        return false;
    }

    private _checkIriModel() {
        if (this.iri && this.iri.model !== this.modelType) {
            throw new Error(
                `Invalid URI for model, the URI '${this.iri.toString()}' is not an URI for the model '${this.modelType.toString()}'`);
        }
    }
}

